module.exports = __webpack_public_path__ + "static/kona-logo-b9e6da34a5acdc6ba3654ea2f9439129.png";